import { Flex, Text, Textarea } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { INVOICE_FOOTER_CHARACTER_LIMIT } from '@features/invoices/constants/invoiceFooterCharacterLimit'
import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { useDebouncedCallback } from '../../../../../../../../../../../../hooks/useDebouncedCallback'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const DefaultInvoiceFooterNote = () => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem, watch } = useFormContext<InvoiceSettingsFormSchema>()

  const footerNote = watch('footerNote')

  const handleDebouncedFooterNoteChange = useDebouncedCallback(() => trackInvoicingSettings('Footer Note Typed'))

  return (
    <FormItem
      name="footerNote"
      label={
        <Flex justifyContent="space-between">
          <Text colorVariant="secondary">
            {t('settings.organization.external_invoice.content.default_footer_note.label')}
          </Text>
          <Text colorVariant="secondary">{`${footerNote.length}/${INVOICE_FOOTER_CHARACTER_LIMIT}`}</Text>
        </Flex>
      }
      render={({ field: { onChange, ...rest } }) => {
        return (
          <Textarea
            {...rest}
            expandOnType
            maxHeight={160}
            maxLength={INVOICE_FOOTER_CHARACTER_LIMIT}
            rows={1}
            onChange={(event) => {
              onChange(event)
              handleDebouncedFooterNoteChange()
            }}
            placeholder={t('settings.organization.external_invoice.content.default_footer_note.placeholder')}
            resizable={false}
          />
        )
      }}
    />
  )
}
